import { Button, Form, Row, Space, Spin, Table } from "antd";
import { ExcelSVG } from "assets";
import { InputFields } from "components/common";
import React, { useEffect, useState } from "react";
import Icon from "assets/icons";
import { columnsTable, dataField } from "./ReportTV.config";
import dayjs from "dayjs";
import { FORMAT_TIME } from "types/enums";
import { medicalExaminationService } from "api";
import { consultantAndFragmentService } from "api";
import Notification from "components/common/notification/notification";

const ReportTV = () => {
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(dataField);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchObjects();
    fetchSourcePatient();
    fetchTypeIOL();
    // getListThuNgan();
  }, []);

  useEffect(() => {
    form.setFieldValue("start", dayjs());
    form.setFieldValue("end", dayjs());
  }, []);

  const fetchObjects = async () => {
    try {
      let response = await medicalExaminationService.getListObjects();
      fields.find((e) => e.name == "doiTuong").options = response.data.map(
        (e) => {
          return { value: e.id, label: e.tenDoiTuong };
        }
      );
      setFields([...fields]);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };

  const fetchSourcePatient = async () => {
    try {
      let response = await medicalExaminationService.getSourcePatient();
      fields.find((e) => e.name == "nguonBn").options = response.data.map(
        (e) => {
          return { value: e.id, label: e.tenNguonBenhNhan };
        }
      );
      setFields([...fields]);
    } catch (err) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
      );
    }
  };

  const fetchTypeIOL = async () => {
    try {
      let response = await medicalExaminationService.getTypeIOL(5);
      fields.find((e) => e.name == "loaiIOLSuDung").options =
        response.data.data.map((e) => {
          return { value: e.id, label: e.tenTheoThuongMai };
        });
      setFields([...fields]);
    } catch (err) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
      );
    }
  };

  const handleOnFinish = (data) => {
    const dataParams = {
      ...data,
      start: dayjs(data.start).format(FORMAT_TIME.dayFull),
      end: dayjs(data.end).format(FORMAT_TIME.dayFull),
    };
    getData(dataParams);
  };

  const getData = async (data) => {
    setLoading(true);
    try {
      const response = await consultantAndFragmentService
        .getDataReportPT(data)
        .then((res) => {
          setData(res.data);
          setLoading(false);
          Notification("success", "Lấy thông tin báo cáo thành công");
        });
    } catch (error) {
      setLoading(false);

      Notification("error", "Đã có lỗi xảy ra khi lấy thông tin báo cáo");
    }
  };

  const handelOnExport = async () => {
    const data = form.getFieldsValue();
    const dataParams = {
      ...data,
      start: data.start ? dayjs(data.start).format(FORMAT_TIME.dayFull) : null,
      end: data.end ? dayjs(data.end).format(FORMAT_TIME.dayFull) : null,
    };
    // console.log('data config export', newData);
    try {
      const response = await consultantAndFragmentService
        .getDataExportReportPT(dataParams)
        .then((res) => {
          // console.log("res export", res);
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `DS bệnh nhân đã phẫu thuật.xlsx`;
          link.click();
          Notification("success", "Đã xuất file báo cáo");
        });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    showSizeChanger: true,
    pageSize: pageSize,
    onChange: handlePaginationChange,
  };

  return (
    <Spin spinning={loading}>
      <div>
        <div className="container">
          <Form form={form} onFinish={handleOnFinish}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                <InputFields data={fields} />
              </Row>
              <Row justify={"end"} style={{ marginTop: "16px" }}>
                <Space>
                  <Button
                    icon={<ExcelSVG />}
                    className="custom-btn"
                    onClick={handelOnExport}
                  >
                    Xuất báo cáo
                  </Button>
                  <Button
                    icon={<Icon.eye rev={0} />}
                    type="ghost"
                    className="btn-sub"
                    htmlType="submit"
                  >
                    Xem thông tin
                  </Button>
                </Space>
              </Row>
            </Space>
          </Form>
        </div>
        <div className="container">
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={data}
            columns={columnsTable}
            scroll={{ x: 2000 }}
          />
        </div>
      </div>
    </Spin>
  );
};

export default ReportTV;
